<div
  class="chip"
  [class]="variant() ? `chip-${variant()}` : ''"
  [class.chip-none]="markerVariant() === 'none'"
  [class.chip-closed]="markerVariant() === 'closed'"
  [style.--status-chip-bg]="colors()?.backgroundColor"
  [style.--status-chip-fg]="colors()?.foregroundColor"
  [style.--status-chip-color]="colors()?.textColor"
>
  <div class="chip-marker"></div>
  <div class="chip-content">
    @if (variant() === 'waiting') {
      Wartend
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
